import React from "react";
import { NewClientDisclaimerModalView } from "./new-client-disclaimer-modal-view";
import type { Properties } from "./properties";

export const NewClientDisclaimerModal = (props: Properties) => {
	return <NewClientDisclaimerModalView {...props} />;
};
